import {AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';
import {ElectronService} from 'ngx-electron';

@Component({
  template: ''
})
export class PlatformAwareComponent implements AfterViewInit {
  static forcePlatform: 'web' | 'electron' | 'win' | 'mac' | undefined = undefined;

  constructor(private elRef: ElementRef,
              private elService: ElectronService) {
  }


  ngAfterViewInit() {
    const nativeElement = this.elRef.nativeElement;
    if (PlatformAwareComponent.forcePlatform) {
      nativeElement.classList.add(PlatformAwareComponent.forcePlatform);
      return;
    }
    if (!this.elService.isElectronApp) {
      nativeElement.classList.add('web');
    } else {
      nativeElement.classList.add('electron');
      if (this.elService.isWindows) {
        nativeElement.classList.add('win');
      }
      if (this.elService.isMacOS) {
        nativeElement.classList.add('mac');
      }
    }
  }
}
